export default function cupFairy(stylesLink) {
  const quiz = [
    {
      id: "questionOne",
      text: "Have you ever had a Menstrual Cup before?",
      description: "Let's see what we already know!",
      fieldNo: 26,
      options: [
        {
          text: "No, it will be my first!",
          route: "questionFour",
        },
        {
          text: "Yes, the pre-baby size of a two cup size brand (i.e. Diva size 1 or similar)",
          route: "questionEight",
        },
        {
          text: "Yes, the post-baby size of a two cup size brand (i.e. Diva size 2 or similar)",
          route: "questionTwo",
        },
        {
          text: "A different kind of cup",
          route: "redirect",
        },
      ],
    },
    {
      id: "questionTwo",
      text: "What did you not like about your previous post-baby cup?",
      description: "Let's see what we can do better this time!",
      fieldNo: 28,
      options: [
        {
          text: "The post-baby size cup was too long (uncomfortable at vaginal entrance)",
          route: "questionThree",
        },
        {
          text: "The post-baby sized cup was too wide and uncomfortable",
          route: "questionFive",
        },
        {
          text: "The post-baby sized cup leaked!",
          route: "questionSix",
        },
      ],
    },
    {
      id: "questionThree",
      text: "We got a cup for that! How was the diameter for you?",
      description:
        "The shorty is a great cup for low cervix when others are too long.",
      fieldNo: 30,
      options: [
        {
          text: "The diameter of the post-baby cup felt fine and sealed well",
          route: "questionSevenV2",
          query: "?size=xl-shorty",
          size: "Shorty XL",
        },
        {
          text: "The diameter of the post baby cup was insufficient and leaked!",
          route: "questionSevenV2",
          query: "?size=xl-shorty",
          size: "Shorty XL",
        },
        {
          text: "The diameter of the post-baby cup felt too wide",
          route: "questionSevenV2",
          query: "?size=large-shorty",
          size: "Shorty Large",
        },
      ],
    },
    {
      id: "questionFour",
      text: "Yay! So excited you are taking the plunge! What can you tell me about yourself?",
      description:
        "Classic is a great firmness for new users. It's easy to fold and remove. Let's keep that in mind, okay?",
      fieldNo: 28,
      options: [
        {
          text: "I am a teen and had no vaginal births",
          route: "questionTen",
        },
        {
          text: "I am an adult and no vaginal births",
          route: "questionNineV1",
        },
        {
          text: "I had one vaginal birth",
          route: "questionNineV2",
        },
        {
          text: "I had multiple vaginal births",
          route: "questionNineV3",
        },
      ],
    },
    {
      id: "questionFive",
      text: "Was the post-baby size just too wide or also too long?",
      description: "Let's get it right this time!",
      fieldNo: 30,
      options: [
        {
          text: "It was just too wide! Length fit fine",
          route: "questionSevenV1",
          query: "?size=large",
          size: "Standard Large",
        },
        {
          text: "It was also too long!",
          route: "questionSevenV2",
          query: "?size=large-shorty",
          size: "Shorty Large",
        },
      ],
    },
    {
      id: "questionSix",
      text: "Other than the Post-Baby size leaking, was the fit okay?",
      description: "We want you to be comfy!",
      fieldNo: 30,
      options: [
        {
          text: "Yes no complaints. Not too long. Not too wide. Just leaks!",
          route: "questionSevenV1",
          query: "?size=xl",
          size: "Standard XL",
        },
        {
          text: "The post baby cup leaked and also felt too long",
          route: "questionSevenV2",
          query: "?size=xl-shorty",
          size: "Shorty XL",
        },
      ],
    },
    {
      id: "questionEight",
      text: "What did you not like about your previous pre-baby cup?",
      description: "Let's figure this out and do better!",
      fieldNo: 28,
      options: [
        {
          text: "It was too long. I could feel it at my vaginal entrance. Width was fine",
          route: "questionSevenV2",
          query: "?size=large-shorty",
          size: "Shorty Large",
        },
        {
          text: "It was too short. I could never reach it",
          route: "questionSevenV1",
          query: "?size=large",
          size: "Standard Large",
        },
        {
          text: "It was too wide and I could feel a lot of pressure.",
          route: "questionSevenV1",
          query: "?size=medium",
          size: "Standard Medium",
        },
        {
          text: "It was both too wide and too long",
          route: "questionSevenV2",
          query: "?size=medium-shorty",
          size: "Shorty Medium",
        },
        {
          text: "It leaked. Dimensions felt fine though!",
          route: "questionSevenV1",
          query: "?size=large",
          size: "Standard Large",
        },
        {
          text: "Something else",
          route: "redirect",
          query: "",
          size: "",
        },
      ],
    },
    {
      id: "questionNineV1",
      text: "Do you have any concerns about cervix height?",
      description:
        "Most cup users are fine with standard cups but if you feel you have reason to assume a below average cervix height, we should factor it in from the start! You can find the downloadable guide here <a href='https://melunausa.blog/2019/10/17/do-you-need-a-low-cervix-cup-free-measuring-tool/'target='_blank'>here</a>",
      fieldNo: 30,
      options: [
        {
          text: "I feel my cervix height is average or higher",
          route: "questionSevenV1",
          query: "?size=medium",
          size: "Standard Medium",
        },
        {
          text: "I feel my cervix height is below average (see blog post on cervix height and download measuring tool if necessary)",
          route: "questionSevenV2",
          query: "?size=large-shorty",
          size: "Shorty Large",
        },
      ],
    },
    {
      id: "questionNineV2",
      text: "Do you have any concerns about cervix height?",
      description:
        "Most cup users are fine with standard cups but if you feel you have reason to assume a below average cervix height, we should factor it in from the start! You can find the downloadable guide here <a href='https://melunausa.blog/2019/10/17/do-you-need-a-low-cervix-cup-free-measuring-tool/'target='_blank'>here</a>",
      fieldNo: 30,
      options: [
        {
          text: "I feel my cervix height is average or higher",
          route: "questionSevenV1",
          query: "?size=large",
          size: "Standard Large",
        },
        {
          text: "I feel my cervix height is below average (see blog post on cervix height and download measuring tool if necessary)",
          route: "questionSevenV2",
          query: "?size=xl-shorty",
          size: "Shorty XL",
        },
      ],
    },
    {
      id: "questionNineV3",
      text: "Do you have any concerns about cervix height?",
      description:
        "Most cup users are fine with standard cups but if you feel you have reason to assume a below average cervix height, we should factor it in from the start! You can find the downloadable guide here <a href='https://melunausa.blog/2019/10/17/do-you-need-a-low-cervix-cup-free-measuring-tool/'target='_blank'>here</a>",
      fieldNo: 30,
      options: [
        {
          text: "I feel my cervix height is average or higher",
          route: "questionSevenV1",
          query: "?size=xl",
          size: "Standard XL",
        },
        {
          text: "I feel my cervix height is below average (see blog post on cervix height and download measuring tool if necessary)",
          route: "questionSevenV2",
          query: "?size=xl-shorty",
          size: "Shorty XL",
        },
      ],
    },
    {
      id: "questionTen",
      text: "Have you ever been sexually active?",
      description:
        "Your answers are not recorded. We simply factor them in to give you a more accurate result",
      fieldNo: 30,
      options: [
        {
          text: "Yes I am/have!",
          route: "questionSevenV1",
          query: "?size=medium",
          size: "Standard Medium",
        },
        {
          text: "No I have not ever",
          route: "questionSevenV1",
          query: "?size=small",
          size: "Standard Small",
        },
      ],
    },
    {
      id: "questionSevenV1",
      text: "Let's talk about handles!",
      description:
        "It's nice to have a handle you love, but remember you can always snip it off, if it bothers you at some point!",
      fieldNo: 32,
      options: [
        {
          text: "The smaller the better. I don't want to know they exist!",
          route: "meluna-menstrual-cup-usa-fda-version-ball-handle-classic",
          handle: "Ball Handle",
        },
        {
          text: "I need all the help I can get to find this cup!",
          route: "meluna-menstrual-cup-usa-fda-version-ring-classic",
          handle: "Ring Handle",
        },
        {
          text: "Noticable enough is nice...but not too much!",
          route: "meluna-menstrual-cup-usa-fda-version-stem-handle-classic",
          handle: "Stem Handle",
        },
      ],
    },
    {
      id: "questionSevenV2",
      text: "Let's talk about handles!",
      description:
        "It's nice to have a handle you love, but remember you can always snip it off, if it bothers you at some point!",
      fieldNo: 32,
      options: [
        {
          text: "The smaller the better. I don't want to know they exist!",
          route:
            "low-cervix-meluna-menstrual-cup-usa-fda-version-ball-handle-shorty-classic",
          handle: "Ball Handle",
        },
        {
          text: "I need all the help I can get to find this cup!",
          route: "menstrual-cup-in-sapphire-blue-shorty-classic-firmness",
          handle: "Ring Handle",
        },
        {
          text: "Noticable enough is nice...but not too much!",
          route: "menstrual-cup-in-clear-shorty-classic-firmness",
          handle: "Stem Handle",
        },
      ],
    },
  ];

  // loop through quiz
  let quizHTML = '<div class="form-container"><form>';
  const userPath = ["questionOne"];
  let selectedOption = [];

  quiz.forEach((question, index) => {
    quizHTML += `
            <fieldset class="form-field quiz-field" ${
              index === 0 ? "" : 'style="display: none;"'
            } data-${question.id}>
                <legend class="question-title">${question.text}</legend>
                <p class="question-info">${question.description}</p>
                <ul class="options-list">
        `;
    question.options.forEach((option, optionIndex) => {
      quizHTML += `
                <li class="option">
                    <div>
                      <input
                        data-question-pointer="${option.route}"
                        data-query="${
                          option.hasOwnProperty("query") ? option.query : ""
                        }"
                        data-size="${
                          option.hasOwnProperty("size") ? option.size : ""
                        }"
                        data-handle="${
                          option.hasOwnProperty("handle") ? option.handle : ""
                        }"
                        data-quiz-option
                        class="form-radio quiz-radio"
                        type="radio"
                        id="${question.id}-option-${optionIndex}"
                        name="quiz_${question.id}"
                        value="${question.text}:${option.text}"
                        data-field-api-id=${question.fieldNo}
                    >
                    </div>
                    <div>
                        <label class="form-label quiz-label" for="${
                          question.id
                        }-option-${optionIndex}">
                        <span class="option-text">${option.text}</span>
                    </label>
                    </div>
                    
                    
                </li>
            `;
    });
    quizHTML += "</ul></fieldset>";
  });

  quizHTML +=
    '<button class="previous-btn btn" type="button" data-previous style="display: none;">Previous</button></form></div>';

  document.getElementById("quiz-container").innerHTML += quizHTML;

  document.body.addEventListener("click", function (event) {
    var target = event.target;
    if (target.getAttribute("data-quiz-option") !== null) {
      var dataPointer = target.getAttribute("data-question-pointer");
      var sizeQuery = target.getAttribute("data-query");
      var cupSize = target.getAttribute("data-size");
      var handle = target.getAttribute("data-handle");
      if (sizeQuery) {
        sessionStorage.setItem("sizeQuery", sizeQuery);
      }
      if (cupSize) {
        sessionStorage.setItem("cupSize", cupSize);
      }
      if (handle) {
        sessionStorage.setItem("handle", handle);
      }

      if (dataPointer.toString().indexOf("question") > -1) {
        showNextQuestion(target);
      } else if (dataPointer.toString() === "redirect") {
        document.querySelector("[data-quiz-results]").innerHTML =
          '<div class="quiz-results"><h2 data-template-msg>Sorry, this one is tough! We suggest making use of our live chat Mon-Fri between 9am and 3pm</h2><button class="button btn" data-retake-quiz>Retake Quiz</button></div>';
        document.querySelector(".form-container").style.display = "none";
        console.log("Finish");
      } else {
        // getProduct(dataPointer, sessionStorage.getItem("sizeQuery"));
        document.querySelector(".form-container").style.display = "none";

        hideQuizDefaultSections();
        putStringWithResult();
        showResultSections();
        showProduct(dataPointer, sessionStorage.getItem("sizeQuery"));
      }
    }
  });

  function showResultSections() {
    const sections = document.querySelectorAll(
      '[data-category="quiz-result-section"]'
    );

    sections.forEach((section) => section.classList.remove("hide"));
  }

  function hideQuizDefaultSections() {
    const sections = document.querySelectorAll(
      '[data-category="quiz-section"]'
    );

    sections.forEach((section) =>
      section.closest(".shopify-section").classList.add("hide")
    );
  }

  function showProduct(handle, query) {
    const sections = Array.from(
      document.querySelectorAll(".featured-product-section")
    );

    if (!sections.length) {
      return;
    }

    const productSection = sections.find(
      (section) => section.dataset.productHandle === handle
    );
    const productURL = productSection.dataset.productUrl;
    const variantField = productSection.querySelector(".variant-id-data");

    productSection.classList.remove("hide");
    window.dispatchEvent(new Event("resize"));

    switchProductVariant(productSection, query);

    variantField.addEventListener("change", (event) => {
      includeNewsletterForm(event.target.value, productURL);
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function switchProductVariant(section, query) {
    const variant = query.replace("?size=", "").toLowerCase();
    const variantsList = Array.from(
      section.querySelectorAll(".block-variant-picker input")
    );
    const matchVariant = variantsList.find(
      (item) => item.value.toLowerCase().replace(" ", "-") === variant
    );

    matchVariant.click();
  }

  function putStringWithResult() {
    const resultHeading = document
      ?.querySelector(".quiz-result-info-about")
      ?.querySelector(".h2");

    if (!resultHeading) {
      return;
    }

    resultHeading.innerHTML = `${sessionStorage.getItem(
      "cupSize"
    )} with ${sessionStorage.getItem("handle")}`;
  }

  const getProduct = (id, query) => {
    console.log(id, query);

    fetch(window.Shopify.routes.root + "products/" + id + ".js  ")
      .then((response) => response.json())
      .then((product) => {
        const productVariants = product.variants;
        let fields = "";
        let str = [];
        const suggestionTextHtml = `Based on the info given your perfect match could be: <div class="result-highlight">${sessionStorage.getItem(
          "cupSize"
        )} with ${sessionStorage.getItem("handle")}</div>`;

        var html =
          '<div class="quiz-results">\
            <h2 data-template-msg>' +
          suggestionTextHtml +
          '</h2>\
            <div data-wufoo-form></div>\
            <span class="or"></span>\
            <div class="btn-action">\
                <a href="' +
          product.url +
          '" data-product-link class="button btn">take me directly to my result</a>\
                <button class="btn" data-retake-quiz>Retake Quiz</button>\
            </div>\
        </div>';

        document.querySelector("[data-quiz-results]").innerHTML = html;

        const suggestionText = `Based on the info given your perfect match could be: ${sessionStorage.getItem(
          "cupSize"
        )} with ${sessionStorage.getItem("handle")}`;

        const linkHref = product.url;
        let isFound = false;
        productVariants.forEach((variant) => {
          if (!isFound) {
            const q = query.replace("?size=", "");
            let variantOption = variant.options;
            variantOption = variantOption.map((option) => {
              return option.toLowerCase().replace(" ", "-");
            });
            if (variantOption.includes(q)) {
              isFound = true;
              document
                .querySelector("[data-product-link]")
                .setAttribute("href", linkHref + "?variant=" + variant.id);
            }
          }
        });
        if (!isFound) {
          document
            .querySelector("[data-product-link]")
            .setAttribute("href", linkHref + query);
        }
        selectedOption[34] = "field34=" + suggestionText;

        var filtered = selectedOption.filter(function (el) {
          return el != null;
        });

        fields = filtered.join("&");
        fields = fields.replaceAll("?", "");

        let url = linkHref + query;
        url = url.replace("https://", "");
        url = url.replace("http://", "");
        fields += "&field40=" + escape(url);

        document.querySelector("[data-wufoo-form]").innerHTML =
          '<iframe id="wufoo-quiz-form" height="560" allowTransparency="true" frameborder="0" scrolling="no" style="width:100%;border:none;" src="https://melunausa.wufoo.com/embed/m61rftk00j750v/def/' +
          fields +
          '"> <a href="https://melunausa.wufoo.com/forms/m61rftk00j750v/">Fill out my Wufoo form!</a></iframe>';

        sessionStorage.clear();
      });
  };

  function includeNewsletterForm(query, productLink) {
    const formContainer = document.querySelector(
      ".newsletter-wufoo-form-container"
    );

    if (!formContainer) {
      return;
    }

    const suggestionText = `Based on the info given your perfect match could be: ${sessionStorage.getItem(
      "cupSize"
    )} with ${sessionStorage.getItem("handle")}`;
    const linkHref = productLink;
    let fields = "";

    selectedOption[34] = "field34=" + suggestionText;

    var filtered = selectedOption.filter(function (el) {
      return el != null;
    });

    fields = filtered.join("&");
    fields = fields.replaceAll("?", "");

    let url = linkHref + `?variant=${query}`;

    url = url.replace("https://", "");
    url = url.replace("http://", "");
  
    fields += "&field40=" + encodeURIComponent(url);

    let iframeSrc = `https://melunausa.wufoo.com/embed/m61rftk00j750v/def/${fields}`;

    formContainer.innerHTML = `<iframe name="wufoo-quiz-form" id="wufoo-quiz-form" height="560" allowTransparency="true" frameborder="0" scrolling="no" style="width:100%;border:none;" src="${iframeSrc}"><a href="https://melunausa.wufoo.com/forms/m61rftk00j750v/">Fill out my Wufoo form!</a></iframe>`;

    sessionStorage.clear();
  }

  const showNextQuestion = (selectedOption) => {
    const nextQuestion = selectedOption.getAttribute("data-question-pointer");
    selectedOption.closest("fieldset").style.display = "none";
    document.querySelector(`[data-${nextQuestion}]`).style.display = "block";

    userPath.push(nextQuestion);

    if (userPath.length === 2) {
      document.querySelector("[data-previous]").style.display = "block";
    }
  };

  const showPrevQuestion = (event) => {
    const lastQuestion = userPath.pop();

    document.querySelector(`[data-${lastQuestion}]`).style.display = "none";
    document.querySelector(
      `[data-${userPath[userPath.length - 1]}]`
    ).style.display = "block";

    if (userPath.length === 1) {
      document.querySelector("[data-previous]").style.display = "none";
    }
  };

  // Click event for elements with the attribute [data-previous]
  document.body.addEventListener("click", function (event) {
    if (event.target.matches("[data-previous]")) {
      showPrevQuestion(event);
    }
  });

  // Click event for elements with the attribute [data-retake-quiz]
  document.body.addEventListener("click", function (event) {
    if (event.target.matches("[data-retake-quiz]")) {
      window.location.reload();
      event.preventDefault();
    }
  });

  // Click event for elements with the class .quiz-radio
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("quiz-radio")) {
      let value = event.target.value.split(":");
      let questionFieldId = parseInt(event.target.dataset.fieldApiId);
      let questionField = "Field" + questionFieldId + "=" + value[0];

      let id = parseInt(event.target.dataset.fieldApiId) + 1;
      let answerFieldId = id;
      let answerField = "Field" + answerFieldId + "=" + value[1];

      selectedOption[questionFieldId] = questionField;
      selectedOption[answerFieldId] = answerField;
    }
  });
}
